/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeleteSystemCategoryComponent } from './delete-system-category.component';
import { RouterModule, Routes } from '@angular/router';
import { SysqueFrameModule } from 'libs/sysque/shared/ui/src/lib/components/sysque-frame';
import { DxButtonModule } from 'devextreme-angular';
import { AlertModule } from '../../../../../shared/ui/src/lib/components/alert';

const routes: Routes = [
  {
    path: 'dialog/delete-system-dialog',
    component: DeleteSystemCategoryComponent,
    data: { isSystemOperation: true },
  },
  {
    path: 'dialog/delete-category-dialog',
    component: DeleteSystemCategoryComponent,
    data: { isSystemOperation: false },
  }
];

@NgModule({
  declarations: [DeleteSystemCategoryComponent],
  imports: [CommonModule, RouterModule.forChild(routes), SysqueFrameModule, DxButtonModule, AlertModule],
  exports: [DeleteSystemCategoryComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DeleteSystemCategoryModule {}
